import { CbhFeatureFlag } from "@src/appV2/FeatureFlags";

import { type INotification } from "./types";

export const NOTIFICATION_DETAILS: Record<string, INotification> = {
  allNotifications: {
    description: "All notifications",
    email: "All",
    sms: "All",
    push: false,
  },
  assignment: {
    description: "Notify me when a worker books a shift",
    email: "assignmentEmail",
    sms: "assignmentSMS",
    push: false,
  },
  shiftUnassignment: {
    description: "Notify me when a worker cancels a shift",
    email: "shiftUnassignmentEmail",
    sms: "shiftUnassignmentSMS",
    push: false,
  },
  workerEta: {
    description: "Notify me if a worker is going to be late for their shift",
    email: "workerEtaEmail",
    sms: "workerEtaSMS",
    push: false,
  },
  chatMessages: {
    description: "Notify me when a worker sends a chat message",
    email: "chatMessages",
    sms: "chatMessages",
    push: "chatMessages",
  },
  invoice: {
    description: "Send me generated invoices (weekly)",
    email: "invoiceEmail",
    sms: false,
    push: false,
  },
  rateNegotiation: {
    description: "Send me rate negotiation updates",
    email: "rateNegotiationEmail",
    sms: false,
    push: false,
    flag: CbhFeatureFlag.RATE_NEGOTIATION_ACTIVATION,
  },
  CDPH530: {
    description: "Send me digital CDPH-530 copies (daily)",
    email: "dailyCDPH530Recap",
    sms: false,
    push: false,
    flag: CbhFeatureFlag.CALIFORNIA_TIMESHEET,
  },
  ewtrEmails: {
    description: "Send extra worked payment (missed punch) request notifications",
    email: "ewtrEmails",
    sms: false,
    push: false,
  },
  wleReplacement: {
    description: "Notify me when a worker left early and a replacement is needed",
    email: "wleReplacementEmail",
    sms: false,
    push: false,
  },
};

export const BATCH_DESCRIPTIONS =
  "We will send you a daily summary for this notification, at the time of your choice.";

export const BATCH_HOURS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const BATCH_MERIDIEM = ["am", "pm"] as const;
